export enum NotificationRemindersTypesEnum {
	'journals' = 'journals',
}
